import { Box, Typography } from '@mui/material'
import React from 'react'

const ConnectWalletError = () => {
    return (
        <div>ConnectWalletError
            <Box>
                <Typography>Connect your wallet to Access all the feature</Typography>
            </Box>
        </div>
    )
}

export default ConnectWalletError